/// Author: Lok Chetri
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Component({
  selector: 'app-tinymce-rich-text-editor',
  templateUrl: './tinymce-rich-text-editor.component.html',
  styleUrl: './tinymce-rich-text-editor.component.scss'
})
export class TinymceRichTextEditorComponent implements OnInit {
  @Input() editorContent: any;
  @Output() updatedEditorContent = new EventEmitter<String>();
  init: EditorComponent['init']; 
  
  constructor(){}

  ngOnInit(): void {
    this.init = {
      license_key: 'gpl',
      plugins: 'lists link image table code wordcount',
      promotion: false,
      branding: false,
      statusbar: false,
      menubar: 'edit insert view format table tools',
      content_style: 'body { font-size: 0.8125rem; font-family: Arial, sans-serif; margin: 8px; }',
      setup: (editor) => {
        editor.on('change', (e) => {
          this.onEditorContentChange(editor.getContent());
        });
      }
    }
  }

  onEditorContentChange(content: string) {
    console.log('Editor content changed:', content);
    this.updatedEditorContent.emit(content);
  }

}
